export default {"src":"/_next/static/media/edit-circle.2e944631.svg","height":8,"width":9};